import { ChangeDetectionStrategy, Component, HostListener, Input, ViewChild } from '@angular/core';

import { makeCustomInputProviders } from './custom-input-component.abstract';
import { InputExpandOnFocusDirective } from './input-expand-on-focus.directive';
import { InputFieldComponent } from './input-field.component';

@Component({
  selector: 'shrd-uic-input-expandable-field',
  templateUrl: './input-expandable-field.component.html',
  styleUrls: ['./input-field.component.scss'],
  providers: makeCustomInputProviders(InputExpandableFieldComponent),
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputExpandableFieldComponent extends InputFieldComponent {
  @Input() expandOnFocusSize: string;
  @Input() expandOnFocusChildClass: string;

  @ViewChild(InputExpandOnFocusDirective) inputExpandOnFocusDirective: InputExpandOnFocusDirective;

  @HostListener('keydown.escape', ['$event'])
  protected onKeyEscape(event: KeyboardEvent): void {
    event.preventDefault();
    this.blur();
  }

  restoreInputInitialState(): void {
    this.inputExpandOnFocusDirective?.restoreInputInitialState();
  }
}
